import Slider from '../slider';

export default (element) => {
  const sliderParent = element.querySelector('[data-collection-slider]');
  const sliderWrapper = sliderParent.querySelector(
    '.collection-section__blocks',
  );
  const slides = sliderWrapper.querySelectorAll('[data-collection-column]');
  const scrollbar = element.querySelector('[data-collection-scrollbar]');
  const showScrollbar = slides.length > 2;
  let slider = null;

  const handleBpChange = () => {
    initSlider();
  };

  const initSlider = () => {
    const isMobileView = window.innerWidth < 1024 && slides.length > 2;
    if (isMobileView) {
      // Re-build markup if previously removed
      slides.forEach((slide) => {
        slide.classList.add('swiper-slide');
      });
      sliderParent.classList.add('swiper');
      sliderWrapper.classList.add('swiper-wrapper');

      const firstSlide = slides.length === 3 || slides.length === 4 ? 1 : 2;
      slider = new Slider({
        el: element.querySelector('[data-collection-slider]'),
        options: {
          slidesPerView: 1.2,
          spaceBetween: 7,
          autoHeight: true,
          initialSlide: firstSlide,
          centeredSlides: true,
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
        },
      });
    } else {
      if (slider) {
        slider.destroy();
      }
      slides.forEach((slide) => {
        slide.classList.remove('swiper-slide');
      });
      sliderParent.classList.remove('swiper');
      sliderWrapper.classList.remove('swiper-wrapper');

      if (!showScrollbar) {
        scrollbar.classList.add('hidden');
      }
    }
  };

  const findSmallestElementHeight = (selector) => {
    let minHeight;

    Array.from(slides).forEach((slide) => {
      const el = slide.querySelector(selector);
      if (el) {
        const height = el.offsetHeight;
        if (!minHeight || height < minHeight) {
          minHeight = height;
        }
      }
    });

    return minHeight;
  };

  const adjustColumnsHeight = () => {
    setTimeout(() => {
      const minHeightImage = findSmallestElementHeight('img');
      const minHeightVideo = findSmallestElementHeight('iframe');
      const minimumHeight = Math.min(
        minHeightImage || Infinity,
        minHeightVideo || Infinity,
      );

      slides.forEach((slide) => {
        const image = slide.querySelector('img');
        const video = slide.querySelector('iframe');

        if (image) {
          const isMobile = window.innerWidth <= 768;
          if (isMobile) {
            if (slides.length <= 2) {
              image.style.height = 'auto';
            } else image.style.height = '410px';
          }
          if (!isMobile) {
            if (slides.length === 3) {
              image.style.height = '612px';
            } else if (slides.length === 4) {
              image.style.height = '458px';
            } else if (slides.length >= 5) {
              image.style.height = '362px';
            } else image.style.height = 'auto';
          }
        }

        if (video) {
          video.style.height = `${minimumHeight}px`;
        }
      });
    }, 500);
  };

  initSlider();
  adjustColumnsHeight();
  window.addEventListener('bpChange', handleBpChange);
};
